import React, { useState, useEffect } from 'react';
import { Form, Col, Button } from 'react-bootstrap';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import { useParams } from 'react-router-dom';
import { validarEntorno } from '../../../../../helpers/validarHost';
import NotificationModal from '../../../../modales/NotificationModal';

import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { useTranslation } from 'react-i18next';


export default function Recomendaciones({ dataG }) {

  console.log(dataG)

  const [inputList, setInputList] = useState([{ recomendacion: "" }]);
  const [showModalNotification, setShowModalNotification] = useState(false);
  const [showModalDeleteNotification, setShowModalDeleteNotification] = useState(false);
  const [showModalConfirmNotification, setShowModalConfirmNotification] = useState(false);
  const [showModalEditNotification, setShowModalEditNotification] = useState(false);
  const [dataTable, setDataTable] = useState(dataG ? dataG : []);
  const [dataTableForm, setDataTableForm] = useState({});
  const [indexDelete, setIndexDelete] = useState('');
  const [indexForm, setIndexForm] = useState('');
  const { t } = useTranslation();

  const handleOpenModalNotification = () => setShowModalNotification(true);
  const handleCloseModalNotification = () => setShowModalNotification(false);

  const handleOpenModalDeleteNotification = (index, item) => {

    console.log(item)
    setShowModalDeleteNotification(true)
    setIndexDelete(index);

    if (indexForm !== index) {
      setIndexForm(index);
      setDataTableForm(item);
    } else {
      setIndexForm('');
      setDataTableForm({});
    }
  };
  const handleCloseModalDeleteNotification = () => setShowModalDeleteNotification(false);

  const handleOpenModalConfirmNotification = () => setShowModalConfirmNotification(true);
  const handleCloseModalConfirmNotification = () => setShowModalConfirmNotification(false);

  const handleOpenModalEditNotification = () => setShowModalEditNotification(true);
  const handleCloseModalEditNotification = () => setShowModalEditNotification(false);


  const { id } = useParams();

  useEffect(() => { }, [dataG])

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;

    if (value !== '') {
      const list = [...inputList];
      list[index][name] = value;
      setInputList(list);
    }


    console.log(inputList)
  };

  const handleRemoveClick = index => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };

  const handleAddClick = () => {
    setInputList([...inputList, { recomendacion: "" }]);
  };

  const sendDataForm = async (e) => {

    e.preventDefault();


    const dataSend = {
      tipo: 'recomendacion',
      accion: 'GUARDAR',
      formData: inputList,
      id: id,
      // id_cuestionario: adk,
      hash: window.location.hash
    };

    console.log(dataSend)


    const response = await validarEntorno('JSON/panoramaRiesgos/GestionInformes/panorama_riesgos_informe_analisis_save_recos.html', 'POST', dataSend);

    if (response.ok) {
      // eslint-disable-next-line no-use-before-define
      const respuesta = await response.json();
      setDataTable(respuesta.recomendaciones);
      setInputList([{ recomendacion: "" }]);
      setShowModalNotification(true);
    }
  }

  const editItem = async (index) => {

    const dataSend = {
      tipo: 'recomendacion',
      accion: 'UPDATE',
      formData: dataTableForm,
      id: id,
      // id_cuestionario: adk,
      hash: window.location.hash
    };

    console.log(dataSend);

    const response = await validarEntorno('JSON/panoramaRiesgos/GestionInformes/panorama_riesgos_informe_analisis_res.html', 'POST', dataSend);

    if (response.ok) {
      // eslint-disable-next-line no-use-before-define
      const respuesta = await response.json();

      if (respuesta.message) {
        let dt = [...dataTable];

        let item = { ...dt[index] };

        item = dataTableForm;

        dt[index] = item;

        setDataTable(dt);

        setDataTableForm({});

        setIndexForm('');

        handleOpenModalEditNotification();
      }
    }

  }

  const deleteItem = async (index, item) => {

    console.log(dataTableForm)

    const dst = dataTable[index];

    const dataSend = {
      tipo: 'recomendacion',
      accion: 'DELETE',
      id: id,
      id_registro: dataTableForm.id,
      hash: window.location.hash
    };

    console.log(dataSend)


    const response = await validarEntorno('JSON/panoramaRiesgos/GestionInformes/panorama_riesgos_informe_analisis_res.html', 'POST', dataSend);

    if (response.ok) {
      const respuesta = await response.json();

      if (respuesta.message) {

        const dt = [...dataTable];

        dt.splice(index, 1);

        setDataTable(dt);

        handleCloseModalDeleteNotification();

        handleOpenModalConfirmNotification();

        setDataTableForm({});

        setIndexForm('');
      }
    }
  }

  const handleTableChangeData = async (e) => {
    const value = e.target.value;
    setDataTableForm({
      ...dataTableForm,
      [e.target.name]: value
    });
  }

  const availableInput = (index, item) => {
    if (indexForm !== index) {
      setIndexForm(index);
      setDataTableForm(item);
    } else {
      setIndexForm('');
      setDataTableForm({});
    }
  }

  return (
    <div>
      <h4 style={{ textAlign: 'start' }} className="pagesTitles">{t('panorama_riesgos.recomendaciones')}</h4>
      <Form className="audit-form" onSubmit={sendDataForm}>
        <Form.Row>
          {inputList.map((item, index) => (
            <>
              <Form.Group key={index} as={Col} lg={12} role="form" controlId="formGridTextArea">
                <Form.Label className="">{t('formulario.label.recomendacion')}</Form.Label>
                <Form.Control
                  className="audit-form-textarea"
                  as="textarea"
                  name="recomendacion"
                  value={item.recomendacion}
                  onChange={e => handleInputChange(e, index)}
                  required
                />
                <Form.Control.Feedback type='invalid'>Este campo es obligatorio</Form.Control.Feedback>
                {inputList.length !== 1 && <RemoveCircleIcon className="icon-gray minus" onClick={() => handleRemoveClick(index)} />}
                {inputList.length - 1 === index && <AddCircleIcon className="icon-gray add" onClick={handleAddClick} />}
              </Form.Group>
            </>
          ))}
        </Form.Row>
        <Form.Row className="btn-form-row">
          <Button className="confirmButton" type="submit">{t('botones.enviar')}</Button>
        </Form.Row>
      </Form>
      <br />
      <br />
      <div className="table-audit-container">
        {dataTable.length > 0 ? (
          <>
            <h4 className="pagesTitles">{t('panorama_riesgos.lista_recomendaciones')}</h4>
            <table   >
              <thead>
                <tr>
                  <th>{t('formulario.label.recomendaciones')}</th>
                  <th>{t('formulario.label.acciones')}</th>
                </tr>
              </thead>
              <tbody>
                {dataTable?.map((item, index) => (
                  <tr key={index} className='rowTabla' style={{ fontSize: '1rem' }}>
                    {indexForm === index ? (
                      <td style={{ width: '70%', padding: '0 20px' }} >
                        <div
                          key={index}
                          as={Col}
                          lg={12}
                          controlId="formGridTextArea"
                        >
                          <Form.Control
                            className="audit-form-textarea-obj"
                            as="textarea"
                            name="recomendacion"
                            defaultValue={item.recomendacion}
                            onChange={handleTableChangeData}
                          />
                        </div>
                      </td>
                    ) : (
                      <td style={{ textAlign: 'justify', width: '80%', paddingLeft: '10px' }}>{item.recomendacion}</td>
                    )}
                    <td  >
                      <div className='botonesTabla'>
                        {indexForm === index ? (
                          <button style={{ cursor: 'pointer' }} className='botonTablaGeneral botonGuardarTabla' onClick={() => { editItem(index) }}>
                            <SaveIcon fontSize='small' />
                            {t('botones.guardar')}
                          </button>
                        ) : null}
                        <button style={{ cursor: 'pointer' }} className='botonTablaGeneral botonEditarTabla' onClick={() => { availableInput(index, item) }}>
                          {indexForm === index
                            ?
                            <>
                              <CloseIcon />
                              {t('botones.cancelar')}
                            </>
                            :
                            <>
                              <EditIcon fontSize='small' />
                              {t('botones.editar')}
                            </>
                          }
                        </button>
                        {indexForm !== index && (
                          <div style={{ cursor: 'pointer' }} className='botonTablaGeneral botonEliminarTabla' onClick={() => { handleOpenModalDeleteNotification(index, item); availableInput(index, item) }}>
                            <DeleteIcon fontSize='small' />
                            {t('botones.eliminar')}
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        ) : null}
      </div>
      <NotificationModal
        isOpen={showModalNotification}
        setIsOpen={handleCloseModalNotification}
        typeModal='saveQuestions'
      />
      <NotificationModal
        isOpen={showModalDeleteNotification}
        itemName="recomendación"
        setIsOpen={handleCloseModalDeleteNotification}
        typeModal='deleteItemConfirm'
        handleEliminar={deleteItem}
        indexDelete={indexDelete}
      />
      <NotificationModal
        isOpen={showModalConfirmNotification}
        itemName="Objetivo"
        setIsOpen={handleCloseModalConfirmNotification}
        typeModal='notificacionItemEliminado'
        handleEliminar={deleteItem}
        indexDelete={indexDelete}
      />
      <NotificationModal
        isOpen={showModalEditNotification}
        itemName="Objetivo"
        setIsOpen={handleCloseModalEditNotification}
        typeModal='notificacionItemActualizacion'
      />
    </div>
  )
}
